module.exports = "/_next/static/images/game-1-phone-attachment-package-7223a248493e6463fbe234b0f514587a.jpg";